import {useFocusEffect, useNavigation} from '@react-navigation/native';
import React, {useCallback, useState} from 'react';
import {RFPercentage} from 'react-native-responsive-fontsize';
import {Header} from '../../components/Interface/Headers/Header';
import {Loading} from '../../components/Interface/Loadings/Loading';
import {CreditCardItem} from '../../components/shared/CreditCard/CreditCardItem';
import {UserCreditCardsDTO} from '../../dtos/UserCreditCardsDTO';

import AsyncStorage from '@react-native-async-storage/async-storage';

import {

  Container,
  Content,
  ContentScroll,
  Footer,
  PaymentsList,
} from './styles';
import {Titles} from '../../components/Interface/Typographies/Titles';
import {Button} from '../../components/Interface/Forms/Buttons/Button';
import {SafeAreaView} from 'react-native-safe-area-context';
import {NotFound} from '../../components/Interface/Search/NotFound';
import {SelectCardTypeModal} from '../../components/shared/Payments/SelectCardTypeModal';


import {BRBModal} from '../../components/shared/BRBModal';
import { useCards } from '../../context/cards';

export function CardsWallet() {
  const navigation = useNavigation();
  const {userCards, fetchUserCreditCardList} = useCards();

  const [isLoading, setIsLoading] = useState(false);

  const [showAddCardModal, setShowAddCardModal] = useState(false);

  async function verifyTermShowed() {
    const term = await AsyncStorage.getItem('creditcard_term');
    if (term === null) {
      setIsLoading(false);
      navigation.navigate('AcceptCreditCardRegulament');
    } else {
      fetchUserCreditCardList({onFinish: () => setIsLoading(false)});
    }
  }

  useFocusEffect(
    useCallback(() => {
      setIsLoading(true);
      verifyTermShowed();
    }, []),
  );

  function handleCreditCard(item: UserCreditCardsDTO) {
    navigation.navigate('CardWalletInfo', {
      id: item.id,
      brand: item.brand,
      expiry: item.expiration,
      number: item.number.substring(12, 16),
      image_url: item.icon,
      voucher: item.voucher,
    });
  }

  function handleAddCreditCard() {
    setShowAddCardModal(true);
  }

  const [showModalBrb, setShowModalBRB] = useState(false);

  return (
    <>
      {isLoading && <Loading />}
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
      <Container>
        <Header icon="chevron-left" />

        <Content>
          <Titles
            title="Meus cartões"
            subtitle="Faça compras e pagamentos com seus cartões cadastrados."
          />

          {/*
          <BannerContainer>
            <BannerButton
              activeOpacity={1}
              style={{
                shadowColor: theme.colors.border,
                shadowOffset: {width: 0, height: 4},
                shadowOpacity: 0.6,
                shadowRadius: 4,
                elevation: 8,
              }}
              onPress={() => setShowModalBRB(true)}>
              <Banner source={bannerBrb} />
            </BannerButton>
          </BannerContainer>
          */}

          <BRBModal
            showModal={showModalBrb}
            onDismiss={() => setShowModalBRB(false)}
          />

          {userCards.length !== 0 ? (
            <ContentScroll showsVerticalScrollIndicator={false}>
              <>
                <PaymentsList>
                  {userCards.map((item, index) => (
                    <CreditCardItem
                      action={() => handleCreditCard(item)}
                      lastFourNumbers={item.number.substring(12, 16)}
                      brand={item.icon}
                      index={index}
                      voucher={item.voucher}
                      isBrb={item.brb}
                      key={item.id}
                    />
                  ))}
                </PaymentsList>
              </>
            </ContentScroll>
          ) : (
            <NotFound
              style={{
                marginTop: -RFPercentage(5),
              }}
              title="Nenhum cartão cadastrado"
              text="Você ainda não cadastrou um cartão de crédito em sua conta."
            />
          )}
        </Content>

        <Footer>

            <SelectCardTypeModal
              onDismiss={() => setShowAddCardModal(false)}
              showModal={showAddCardModal}
            />
            <Button
              title="Adicionar cartão"
              onPress={handleAddCreditCard}
              enabled
            />

        </Footer>
      </Container>
      </SafeAreaView>
    </>
  );
}
